import React from 'react';
import Sidebar from '../Sidebar/Sidebar';
import { useStaffNav } from '../Sidebar/shellNav';
import AppShell from './AppShell';

/** The staff shell: the role-filtered rail, the top bar and the page column. */
function Layout({ children }) {
  const nav = useStaffNav();
  return (
    <AppShell nav={nav} sidebar={(shell) => <Sidebar nav={nav} {...shell} />}>
      {children}
    </AppShell>
  );
}

export default Layout;
